import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsMemoryMessages = defineMessages("settings-memory", en);
